import { useState } from "react";
import { Link, useNavigate } from "react-router";
import { Button, Icon, IconButton, Sheet, useConfirmSafe } from "@xinghai/ui";
import { useAuth, useLogout } from "../features/auth/useAuth";
import { pendingCount, useUploadQueue } from "../lib/queue";
import { ROLE_LABELS } from "./roles";

/**
 * 账号与安全 for every role (ACCOUNTS.md §3). A sheet rather than a hover
 * dropdown so it works the same on a phone and on the desktop.
 */
export function AccountMenu() {
  const { me } = useAuth();
  const [open, setOpen] = useState(false);
  const logout = useLogout();
  const navigate = useNavigate();
  const confirm = useConfirmSafe();
  // docs/ROADMAP.md B2 — 退出前先提醒还没传完的录音。
  const queued = pendingCount(useUploadQueue());

  if (!me) return null;

  return (
    <>
      <IconButton icon={<Icon id="ui-user" />} label="账号与安全" onClick={() => setOpen(true)} />
      <Sheet open={open} onClose={() => setOpen(false)} title="账号与安全" size="sm">
        <p className="xz-account__who">
          <strong>{me.user.display_name || me.user.username}</strong>
          <span className="gz-caption">
            {me.user.roles.map((r) => ROLE_LABELS[r] ?? r).join(" · ")}
          </span>
        </p>
        <nav className="xz-account__links">
          <Link className="gz-button" to="/account/profile" onClick={() => setOpen(false)}>
            <Icon id="ui-user" size={20} /> 我的资料
          </Link>
          <Link className="gz-button" to="/account/password" onClick={() => setOpen(false)}>
            <Icon id="ui-key" size={20} /> 修改密码
          </Link>
          <Link className="gz-button" to="/account/devices" onClick={() => setOpen(false)}>
            <Icon id="ui-shield" size={20} /> 我的设备
          </Link>
          <Link className="gz-button" to="/account/email" onClick={() => setOpen(false)}>
            <Icon id="ui-inbox" size={20} /> 找回邮箱
          </Link>
          <Link className="gz-button" to="/account/phone" onClick={() => setOpen(false)}>
            <Icon id="ui-key" size={20} /> 找回手机
          </Link>
          <Button
            variant="secondary"
            loading={logout.isPending}
            onClick={async () => {
              if (queued > 0) {
                const ok = await confirm({
                  title: `还有 ${queued} 条录音没传上去`,
                  message:
                    "退出登录后这些录音要等你重新登录才会继续补传。先连上网等它传完会更稳妥。",
                  confirmLabel: "仍然退出",
                  cancelLabel: "再等等",
                  danger: true,
                });
                if (!ok) return;
              }
              await logout.mutateAsync().catch(() => undefined);
              setOpen(false);
              void navigate("/login", { replace: true });
            }}
          >
            <Icon id="ui-logout" size={20} /> 退出登录
          </Button>
        </nav>
      </Sheet>
    </>
  );
}
